import dayjs from 'dayjs';
import { TWorkshopTimezone } from 'data/types/workshops.types';

const parseTime = (time: string) => dayjs(time, 'HH:mm:ss').format('h:mm A');

export const formatTimeRange = (
  startTime?: string,
  endTime?: string,
  timezone?: TWorkshopTimezone | null,
): string | null => {
  if (!startTime) return null;

  const start = parseTime(startTime);
  const end = endTime ? parseTime(endTime) : null;

  const timePart = end ? `${start} – ${end}` : start;
  return timezone ? `${timePart} ${timezone}` : timePart;
};
